import { baseRequest } from './base'

/**
 * @desc 验证码登录接口
 */
function smsLogin(params) {
  return baseRequest('/api/pcWeb/smsLogin', 'post', params)
}

/**
 * @desc 密码登录接口
 */
function login(params) {
  return baseRequest('/api/pcWeb/login', 'post', params)
}

/**
 * @desc 中心校登录
 */

function centerLogin(params) {
  return baseRequest('/api/schoolManagement/login', 'post', params)
}

/**
 * @desc 中心校验证码登录
 */
function centerSmsLogin(params) {
  return baseRequest('/api/schoolManagement/smsLogin', 'post', params)
}

/**
 * @desc 获取学校列表
 */

function getSchoolList(params) {
  return baseRequest('/api/schoolManagement/list', 'post')
}

/**
 * @desc 初始化接口
 */
function getCurrentUser() {
  return baseRequest('/api/pcWeb/accUser/getCurrentUser', 'get')
}

/**
 * @desc 获取验证码
 */
function getSmscode(params) {
  return baseRequest(`/api/pcWeb/common/getSmscode`, 'get', params)
}

/**
 * @desc 初始化接口
 */
function init() {
  return baseRequest('/api/pcWeb/common/init', 'get')
}

/**
 * @desc 修改密码
 */
function updatePassword(params) {
  return baseRequest('/api/pcWeb/accUser/updatePassword', 'post', params)
}

/**
 * @desc 个人中心修改信息
 */
function updateUserCenterInfo(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  return baseRequest('/api/pcWeb/accUser/updateUserCenterInfo', 'post', params)
}

// /api/pcWeb/common/getBureau 不再使用，请参考bureau.js

/**
 * @desc 清除cookie
 */
function exit() {
  return baseRequest('/api/schoolManagement/exit', 'get')
}

/**
 * @desc 第三方平台登录接口
 */
function thirdPartyLogin(params) {
  let tempUrl = '/api/pcWeb/loginExternal'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * 课程方入驻，获取验证码
 * @param {*} params
 * @returns
 */

function getRegisterSmscode(params) {
  return baseRequest('/api/pcWeb/servicePlatform/sendSmsCode', 'post', params)
}
/**
 * @desc 课程方入驻，校验验证码
 */

const registerAfterSchool = (registeredServiceForm) => {
  return baseRequest(
    '/api/pcWeb/servicePlatform/enterInstitution',
    'post',
    registeredServiceForm
  )
}

/**
 * 提交信息
 * @param {*} data
 * @returns
 */

const submitInformation = (data) => {
  return baseRequest(
    '/api/pcWeb/servicePlatform/enterInstitutionStepTwo',
    'post',
    data
  )
}

/**
 *获取个人/课程方所有信息
 * @returns
 */
const getInformation = () => {
  return baseRequest('/api/pcWeb/servicePlatform/institutionInfo', 'get')
}

/**
 *保存信息不提交
 * @returns
 */
const saveInstitution = (data) => {
  return baseRequest(
    '/api/pcWeb/servicePlatform/saveInstitutionTwo',
    'post',
    data
  )
}

/**
 *查看申请记录
 * @returns
 */
const queryingApplicationStatus = (values) => {
  return baseRequest('/api/pcWeb/servicePlatform/viewRecords', 'post', values)
}

/**
 * @desc 获取BItoken
 */
 function getBiToken(params) {
  return baseRequest(`/api/pcWeb/common/getBiToken`, 'get', params)
}

export default {
  login: login,
  smsLogin: smsLogin,
  centerLogin,
  centerSmsLogin,
  getSchoolList,
  init: init,
  getSmscode: getSmscode,
  getCurrentUser: getCurrentUser,
  updatePassword: updatePassword,
  updateUserCenterInfo: updateUserCenterInfo,
  thirdPartyLogin,
  registerAfterSchool,
  getRegisterSmscode,
  submitInformation,
  getInformation,
  saveInstitution,
  queryingApplicationStatus,
  exit,
  getBiToken
}
